import { Typography } from "@packages/ds";
import styled from "styled-components";

export const List = styled.ul`
  margin: 0;
  padding-left: 25px;
`;

export const IncrementNoticeLabel = styled(Typography.Label)`
  font-weight: 400;
`;
